// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoSuggestionsPanel_root__MwL_U","title":"VideoSuggestionsPanel_title__3nEZQ","list":"VideoSuggestionsPanel_list__3REIb"};